import styled from "styled-components";

const Container = styled.section`
  width: 100%;
  height: ${({ screen }) => (screen ? "100vh" : "auto")};
  margin: 0 auto;
  position: ${({ relative }) => (relative ? "relative" : "static")};
  box-sizing: border-box;
  padding: ${({ padding }) => padding};
  #logo {
    z-index: 11;
  }
  @media (max-width: 600px) {
    padding: 3rem 2rem 0 2rem;
  }
  @media screen and (min-width: 576px) {
    max-width: 576px;
  }
  @media screen and (min-width: 768px) {
    max-width: 768px;
  }
  @media screen and (min-width: 992px) {
    max-width: 992px;
  }
  @media screen and (min-width: 1200px) {
    max-width: calc(100vw - 100vw / 6 + 2.5%);
  }
`;

export default Container;
